import { Link } from "react-router";
import { useLocation } from "react-router";
import { useTranslation } from "react-i18next";
import { useEffect, useState } from "react";
import LanguageSelector from "../components/LanguageSelector";

export default function HeaderSection() {
  const { t } = useTranslation();
  const location = useLocation();
  const [isMenuOpen, setIsMenuOpen] = useState(false);
  const anchorPrefix = location.pathname === "/" ? "" : "/";

  const navigation = [
    { href: `${anchorPrefix}#selection`, label: t("nav.selection") },
    { href: `${anchorPrefix}#assessment`, label: t("nav.assessment") },
    { href: `${anchorPrefix}#coaching`, label: t("nav.coaching") },
    { href: `${anchorPrefix}#contact`, label: t("nav.contact") }
  ];

  useEffect(() => {
    setIsMenuOpen(false);
  }, [location.pathname, location.hash]);

  return (
    <header className="fixed left-0 right-0 top-0 z-50 border-b border-white/10 bg-[#111111]/90 text-white backdrop-blur">
      <div className="mx-auto flex max-w-7xl flex-wrap items-center justify-between gap-x-4 gap-y-3 px-4 py-3 sm:px-6 lg:px-0 lg:py-4">
        <Link
          className="shrink-0 text-lg font-semibold uppercase text-white transition duration-200 hover:text-[#B08D57] focus-visible:outline focus-visible:outline-2 focus-visible:outline-offset-4 focus-visible:outline-[#B08D57]"
          to="/"
          aria-label={t("nav.home_label")}
          onClick={() => setIsMenuOpen(false)}
        >
          <img src="/logo.png" alt="Logo" className="h-14 sm:h-16 lg:h-20" />
        </Link>

        <nav
          id="site-navigation"
          className={`${isMenuOpen ? "flex" : "hidden"} order-3 w-full flex-col border-t border-white/10 pt-3 font-medium md:order-none md:flex md:w-auto md:flex-row md:items-center md:gap-x-4 md:border-t-0 md:pt-0 lg:gap-x-8`}
          aria-label={t("nav.aria_label")}
        >
          {navigation.map((item) => (
            <a
              key={item.href}
              className="border-b border-white/10 py-3 text-base font-medium text-white/80 transition duration-200 last:border-b-0 hover:text-[#B08D57] focus-visible:outline focus-visible:outline-2 focus-visible:outline-offset-4 focus-visible:outline-[#B08D57] md:border-b-0 md:py-0 lg:text-lg"
              href={item.href}
              onClick={() => setIsMenuOpen(false)}
            >
              {item.label}
            </a>
          ))}
        </nav>

        <div className="flex items-center gap-4">
          <a
            className="hidden min-h-10 items-center border border-[#B08D57] px-4 py-2 text-xs font-semibold uppercase text-[#B08D57] transition duration-200 hover:bg-[#B08D57] hover:text-[#111111] focus-visible:outline focus-visible:outline-2 focus-visible:outline-offset-4 focus-visible:outline-[#B08D57] md:inline-flex"
            href={`${anchorPrefix}#contact`}
          >
            {t("nav.cta")}
          </a>
          <LanguageSelector />
          <button
            className="flex h-10 w-10 shrink-0 items-center justify-center border border-white/20 transition duration-200 hover:border-[#B08D57] focus-visible:outline focus-visible:outline-2 focus-visible:outline-offset-4 focus-visible:outline-[#B08D57] md:hidden"
            type="button"
            aria-label={isMenuOpen ? "Close navigation" : "Open navigation"}
            aria-controls="site-navigation"
            aria-expanded={isMenuOpen}
            onClick={() => setIsMenuOpen((previous) => !previous)}
          >
            <span className="relative h-4 w-5" aria-hidden="true">
              <span className={`${isMenuOpen ? "top-2 rotate-45" : "top-0"} absolute left-0 h-0.5 w-5 bg-white transition-all duration-200`} />
              <span className={`${isMenuOpen ? "opacity-0" : "opacity-100"} absolute left-0 top-2 h-0.5 w-5 bg-white transition-all duration-200`} />
              <span className={`${isMenuOpen ? "top-2 -rotate-45" : "top-4"} absolute left-0 h-0.5 w-5 bg-white transition-all duration-200`} />
            </span>
          </button>
        </div>
      </div>
    </header>
  );
}
